import PV from "../utility/petite-vue";
import {InitializeMediaReveals} from "../utility/init-gsap";
import {getUrlParams, setURLParams, scrollToEl} from "../utility/utils";

const PostGrid = (postsData) => {
  const data = postsData;

  return {
    posts: data.posts,
    initialized: false,
    allFilteredResults : data.posts,
    postsPerLoad: 9,
    postsOnLoad: 10,
    postsLoaded: null,
    filters: data.filters,
    activeFilter: {slug:null,name:null},
    displayLoadMore: false,
    block_el: data.id,
    filter_el: null,

    mounted() {
      this.initialized = true;

      this.$nextTick( () => {
        this.filter_el = this.block_el.querySelector('.post_feed__filter_wrap');
        this.updateExternalStuff();
      });
    },


    updateExternalStuff(){
      InitializeMediaReveals();
    },
    
    loadMore() {
      const currentLoadedCount = this.postsLoaded.length;
      const totalCount = this.allFilteredResults.length;
      const newCount = (totalCount - this.postsPerLoad) > currentLoadedCount ? currentLoadedCount + this.postsPerLoad : totalCount;
      this.postsLoaded = this.allFilteredResults.slice(0, newCount);
      this.displayLoadMore = this.postsLoaded.length < this.allFilteredResults.length;

      this.$nextTick( () => {
        this.updateExternalStuff()
      });
    },

    get urlParameters(){
      const urlParams = getUrlParams();

      if(urlParams.category){
        this.activeFilter.slug = urlParams.category;

        this.filters.forEach(filter => {
          if(filter.slug == this.activeFilter.slug){
            this.activeFilter.name = filter.name;
          }
        });
      }

      this.filterPosts();
    },

    setURL(){
      // Update the URL used for sharing
      const urlParams = {
        'category' : this.activeFilter.slug ? this.activeFilter.slug : false
      };

      setURLParams(urlParams);
    },

    selectFilterPosts(){
      const mobileSelect = this.block_el.querySelector('select');
      const value = mobileSelect.value;

      if(value == 'null' || !value){
        this.filterPosts({slug:null, name: null});
      }
      else {
        const valueArray = value.split(",");
        this.filterPosts({slug:valueArray[0], name: valueArray[1]});
      }
    },

    filterPosts(filter = false){
      if(filter){
        if(filter.slug == this.activeFilter.slug){
          return;
        }

        this.activeFilter.slug = filter.slug;
        this.activeFilter.name = filter.name;
      }

      let allFilteredResults = [...this.posts];

      if(this.activeFilter.slug){
        allFilteredResults = allFilteredResults.filter((post) => {
          let include = false;

          if(post.categories){
            post.categories.forEach(term => {
              if(term.slug == this.activeFilter.slug){
                include = true;
              }
            });
          }

          return include;
        });
      }

      this.allFilteredResults = allFilteredResults;
      this.postsLoaded = allFilteredResults.slice(0,this.postsOnLoad);
      this.displayLoadMore = this.postsLoaded.length < this.allFilteredResults.length;
      this.setURL();
      this.$nextTick( () => {
        this.updateExternalStuff()
      });
    },
  };
}

export const InitializePostGrid = () => {
  PV.registerScope( "PostGrid", PostGrid );
}